export default "__VITE_ASSET__Bi68GF2w__"